export const regimesSecu = [
	'Général/Local',
	'Indépendant',
	'Agricole/MSA',
	'Conseil Européen',
	'Autre'
];
